import { GetIndexInfoByExpressionId, RequestIndexDetail } from '@/api/whiteList/eventBack.js'
import { GenerateFactorTaskOverlay, GenerateEventOverlay, GetJsonByExpressionId } from '@/api/whiteList/inclusionIndex.js'

async function performApiCall (apiFunction, statusObj, maxRetries = 10, retryInterval = 1000) {
  let retryCount = 0

  while (retryCount < maxRetries) {
    try {
      const response = await apiFunction(statusObj)
      if (response.status === 200 && response.data.code === 0 && response.data.data) {
        return response.data.data
      }
    } catch (error) {
      console.error(`Error fetching data: ${error}`)
    }

    retryCount++
    console.log(`Retry attempt ${retryCount}/${maxRetries}`)
    await new Promise(resolve => setTimeout(resolve, retryInterval))
  }

  console.error(`Failed to fetch data after ${maxRetries} retries`)
  throw new Error('Failed to fetch data')
}
// 根据 expression_id 获取 曲线查询数据的ID （涉及到异步轮询获取数据）
async function getIndexInfoByExpressionId (statusObj) {
  return performApiCall(GetIndexInfoByExpressionId, statusObj)
}
// 根据id获取曲线详情数据
async function requestIndexDetail (statusObj) {
  return performApiCall(RequestIndexDetail, statusObj)
}

// 回测任务区间叠加图
async function generateFactorTaskOverlay (statusObj) {
  return performApiCall(GenerateFactorTaskOverlay, statusObj)
}
// 回测任务区间叠加图
async function generateEventOverlay (statusObj) {
  return performApiCall(GenerateEventOverlay, statusObj)
}
// 通过 ExpressionId 获取 json 数据
async function getJsonByExpressionId (statusObj) {
  return performApiCall(GetJsonByExpressionId, statusObj)
}

export default {
  getIndexInfoByExpressionId,
  requestIndexDetail,
  generateFactorTaskOverlay,
  generateEventOverlay,
  getJsonByExpressionId
}



// WEBPACK FOOTER //
// ./src/views/whiteList/weChatMsgReply/InclusionIndex/controller/ApiFunc.js